export const INSTITUTE_TYPES = {
  SCHOOL: "SCHOOL",
  COLLEGE: "COLLEGE",
  COACHING: "COACHING",
};
